module.exports = __webpack_public_path__ + "static/media/18ECA4.534e3727.jpg";